"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseProductCode = void 0;
const errors_1 = require("./errors");
const fields_1 = require("./fields");
const utils_1 = require("./utils");
const parseProductCode = (productCode) => {
    const { groups } = productCode.match(productPattern) || {};
    if (!groups) {
        throw new errors_1.InvalidProductCode(productCode);
    }
    const parsedProductCode = {
        productFamily: (0, utils_1.pick)(fields_1.ProductFamily, groups.productFamily),
        productVersion: (0, utils_1.pick)(fields_1.ProductVersion, groups.productVersion),
        platformName: (0, utils_1.pick)(fields_1.PlatformName, groups.platformName),
        billingCycle: (0, utils_1.pick)(fields_1.BillingCycle, groups.billingCycle),
        licenseType: (0, utils_1.pick)(fields_1.LicenseType, groups.licenseType),
        productSubType: (0, utils_1.pick)(fields_1.ProductSubType, groups.productSubType),
        unitOfMeasurement: (0, utils_1.pick)(fields_1.UnitOfMeasurement, groups.unitOfMeasurement),
        quantity: parseQuantity(groups.unitQuantity),
    };
    return Object.freeze(parsedProductCode);
};
exports.parseProductCode = parseProductCode;
const units = {
    K: 1000,
    T: 10000,
    H: 100000,
    M: 1000000,
};
const parseQuantity = (qty) => qty[2] in units
    ? parseInt(qty.slice(0, 2)) * units[qty[2]]
    : qty[1] in units
        ? parseFloat(`${qty[0]}.${qty[2]}`) * units[qty[1]]
        : parseInt(qty);
const productPattern = new RegExp([
    '^',
    (0, utils_1.compileEnum)(fields_1.ProductFamily, 'productFamily'),
    (0, utils_1.compileEnum)(fields_1.ProductVersion, 'productVersion'),
    (0, utils_1.compileEnum)(fields_1.PlatformName, 'platformName'),
    (0, utils_1.compileEnum)(fields_1.BillingCycle, 'billingCycle'),
    (0, utils_1.compileEnum)(fields_1.LicenseType, 'licenseType'),
    (0, utils_1.compileEnum)(fields_1.ProductSubType, 'productSubType'),
    (0, utils_1.compileEnum)(fields_1.UnitOfMeasurement, 'unitOfMeasurement'),
    '(?<unitQuantity>(?:\\d[KTHM]\\d)|(?:\\d\\d[KTHM])|(?:\\d{3}))',
    '$',
].join(''));
//# sourceMappingURL=parseProductCode.js.map